import { MainInner } from "@/styles/global";
import { Paragraph, ParagraphBig, h1, h4 } from "@/styles/typography";
import { Link } from "gatsby";
import styled from "styled-components";

const Inner = styled(MainInner)`
  gap: 24px;
`;

const Title = styled(h1)`
  color: ${({ theme }) => theme.colors.textHeading};
  max-width: 850px;
`;

const Ingress = styled(ParagraphBig)`
  max-width: 850px;
`;

const CardsWrapper = styled.div`
  display: flex;
  gap: 16px;
  height: 100%;
  width: 100%;

  .mySwiper {
    width: 100%;
    height: 100%;
    overflow: visible;
  }
`;

const CardIcon = styled.span`
  margin-top: auto;
  transition: transform 0.3s ease-in-out;
`;

const Card = styled(Link)<{ $bgColor: string }>`
  min-width: 272px;
  height: 287px;
  padding: 16px;
  background-color: ${({ $bgColor }) => $bgColor};
  text-decoration: none;
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  border-radius: 4px;
  transition: filter 0.3s ease-in-out;

  &:hover {
    filter: brightness(1.1);

    h4 {
      text-decoration-color: ${({ $bgColor, theme }) =>
        $bgColor === "#534B93"
          ? theme.colors.coreLight
          : theme.colors.textHeading};
    }

    ${CardIcon} {
      transform: translateX(10px);
    }
  }

  h4,
  p {
    color: ${({ $bgColor, theme }) =>
      $bgColor === "#534B93"
        ? theme.colors.coreLight
        : theme.colors.textHeading};
  }
  svg path {
    stroke: ${({ $bgColor, theme }) =>
      $bgColor === "#534B93"
        ? theme.colors.coreLight
        : theme.colors.textHeading};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    height: 377px;
    width: 100%;
  }
`;

const CardTitle = styled(h4)`
  text-decoration: underline;
  text-decoration-color: transparent;
  transition: 0.3s;
`;

const CardIngress = styled(Paragraph)``;

const NavigationWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;

  @media (min-width: 1350px) {
    display: none;
  }
`;

const Navigation = styled.button`
  width: 46px;
  height: 46px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: transparent;
  cursor: pointer;

  .firstArrow {
    transform: rotate(90deg);
  }

  svg {
    transform: rotate(-90deg);
    height: 40px;
    width: 40px;
  }

  &:disabled {
    cursor: not-allowed;

    svg path {
      fill: darkgrey;
    }
  }
`;

const S = {
  Inner,
  Title,
  Ingress,
  CardsWrapper,
  Card,
  CardTitle,
  CardIngress,
  CardIcon,
  NavigationWrapper,
  Navigation,
};

export default S;
